// Contenu des pages marketing et entreprise.
// Aucun logo client, aucun chiffre d'usage, aucun témoignage fabriqué :
// le service vient d'ouvrir et la page le dit.

export const PRICING = {
  eyebrow: "Tarifs",
  title: "De 56 à 200 € la séance.",
  lead: "Un seul coach, un tarif qui dépend de ce que vous demandez. Quatre critères, additionnés à une base : le détail est ci-dessous, sans « à partir de » trompeur.",
  notice: "Les paiements en ligne ne sont pas encore activés. Cette grille décrit le tarif qui s'appliquera à leur ouverture.",
  faq: [
    { q: "Pourquoi un écart de 56 à 200 € ?", a: "Une heure de relecture sur League of Legends et deux heures de préparation à un tournoi Counter-Strike ne demandent ni le même temps, ni la même préparation en amont. Le tableau ci-dessus détaille chaque écart." },
    { q: "Le module personnalisé, concrètement ?", a: "Vos parties sont visionnées avant la séance et les exercices sont construits à partir de ce qui en ressort. Le module standard suit une progression commune, efficace mais non adaptée à votre cas." },
    { q: "Pourquoi les FPS coûtent-ils plus cher ?", a: "L'analyse s'y fait image par image : visée, timing, placement, prise d'information. La préparation d'une séance y est plus longue que sur un jeu où la décision se lit à l'échelle de la seconde." },
    { q: "Y a-t-il un abonnement ?", a: "Non. Vous payez la séance que vous réservez, rien d'autre. Aucune reconduction automatique." },
    { q: "Puis-je annuler ?", a: "Oui, gratuitement jusqu'à 24 heures avant. Le détail figure dans la politique d'annulation." },
  ],
};

export const FEATURES = {
  eyebrow: "Fonctionnalités",
  title: "Ce que fait Perform.",
  lead: "Une plateforme de coaching, pas un réseau social. Chaque élément sert la progression.",
  live: [
    { icon: "Users", title: "Un coach, cinq jeux", text: "League of Legends, Counter-Strike 2, Call of Duty, Fortnite et EA FC. Rien de plus, pour bien le faire.", to: "/coach" },
    { icon: "Target", title: "Objectifs et progression", text: "Un objectif par période, suivi d'une séance à l'autre. Votre courbe de progression est visible dès le tableau de bord.", to: "/dashboard" },
    { icon: "LifeBuoy", title: "Prise en main guidée", text: "Six étapes pour passer du compte vide à la première séance réservée.", to: "/aide" },
  ],
  building: [
    { icon: "Video", title: "Analyse de VOD", text: "Déposez une partie, le coach l'annote image par image et vous laisse des notes consultables après la séance." },
    { icon: "Radio", title: "Salle de coaching live", text: "Session en direct, écran partagé, prise de notes partagée." },
    { icon: "Sparkles", title: "Perform AI", text: "Un analyste entre deux séances. Aucune donnée n'est envoyée à un modèle aujourd'hui — voir la page Transparence IA." },
    { icon: "GitCommitHorizontal", title: "Paiements et versements", text: "Paiement sécurisé à la réservation, confirmation immédiate du créneau." },
  ],
};

export const AUDIENCES = {
  joueurs: {
    eyebrow: "Pour les joueurs", title: "Un coach qui regarde vraiment votre jeu.",
    lead: "Pas de contenu générique. Un coach qui connaît votre jeu, votre rôle et votre palier, et qui vous dit ce que vous ne voyez pas.",
    points: [
      { icon: "Users", title: "Un interlocuteur unique", text: "Le même coach d'une séance à l'autre : il connaît déjà votre jeu, vos erreurs et votre objectif." },
      { icon: "Target", title: "Un objectif, pas un abonnement", text: "Vous réservez une séance pour un objectif précis. Pas d'engagement, pas de reconduction automatique." },
      { icon: "Video", title: "Des traces qui restent", text: "Notes et objectifs restent accessibles après la séance. Vous relisez, vous appliquez, vous revenez." },
    ],
    cta: { label: "Voir la methode", to: "/coach" },
  },
  equipes: {
    eyebrow: "Pour les équipes et les clubs", title: "Faire progresser un roster, pas un joueur.",
    lead: "Pour les structures qui suivent plusieurs joueurs et veulent un encadrement cohérent d'un membre à l'autre.",
    points: [
      { icon: "Users", title: "Comptes gérés", text: "La structure crée et administre les comptes de ses membres, et garde la main sur les accès." },
      { icon: "Activity", title: "Vue d'ensemble", text: "Progression du roster, séances réalisées et objectifs en cours, au même endroit." },
      { icon: "ShieldCheck", title: "Cadre contractuel", text: "Accord de traitement des données au sens de l'article 28 du RGPD, signé avant toute mise en service." },
    ],
    cta: { label: "Parler à quelqu'un", to: "/contact" },
    notice: "Les fonctionnalités d'équipe sont en cours de construction. Écrivez-nous : nous construisons cette offre avec les premières structures.",
  },
};

export const ABOUT = {
  eyebrow: "À propos", title: "Perform.",
  lead: "Une plateforme française de coaching esport, ouverte en 2026.",
  sections: [
    { heading: "Pourquoi", body: [
      "Des millions de joueurs s'entraînent seuls, répètent les mêmes erreurs et progressent lentement. Les guides génériques n'aident pas : personne ne regarde leur jeu à eux.",
      "Dans le même temps, beaucoup de très bons joueurs coachent déjà, mais sans outils, sans visibilité et sans cadre. Perform relie les deux.",
    ]},
    { heading: "Comment", body: [
      "Nous croyons à la séance courte, régulière et orientée vers un objectif précis, plutôt qu'au programme de trois mois qu'on abandonne au bout de deux semaines.",
      "Nous publions ce que nous faisons : notre posture de sécurité, ce qui fonctionne et ce qui manque encore. C'est plus utile qu'une plaquette.",
    ]},
    { heading: "Où nous en sommes", body: [
      "Le service vient d'ouvrir. Nous n'avons pas de logos clients à afficher ni de chiffres d'usage à mettre en avant, et nous préférons le dire plutôt que d'en inventer.",
    ]},
  ],
};

export const MANIFESTO = {
  eyebrow: "Manifeste", title: "Un peu mieux, chaque jour.",
  lead: "Ce en quoi nous croyons, et ce que cela change dans le produit.",
  beliefs: [
    { title: "La progression est ennuyeuse, et c'est normal", text: "On ne monte pas de division grâce à une astuce. On monte en corrigeant une erreur, puis une autre. Le produit privilégie le suivi régulier plutôt que la promesse spectaculaire." },
    { title: "Un coach n'est pas un joueur classé", text: "Savoir jouer et savoir expliquer sont deux métiers. Nous vérifions les deux." },
    { title: "Pas d'engagement déguisé", text: "Aucune reconduction automatique, aucun abonnement qui tourne pendant qu'on ne l'utilise pas. Vous payez la séance." },
    { title: "La transparence vaut mieux que le vernis", text: "Nous publions nos manques de sécurité aussi clairement que nos acquis. Un badge de certification qu'on n'a pas obtenu ne trompe que les gens de bonne foi." },
    { title: "Le temps de jeu n'est pas une métrique de succès", text: "Nous ne cherchons pas à vous garder connecté. Nous cherchons à ce que vous progressiez, puis que vous alliez jouer." },
  ],
};

export const CAREERS = {
  eyebrow: "Carrières", title: "Travailler chez Perform.",
  lead: "Une petite équipe, en France, qui construit une plateforme sérieuse pour une pratique qui l'est devenue.",
  notice: "Aucun poste n'est ouvert aujourd'hui. Les candidatures spontanées restent lues : écrivez-nous si le projet vous parle.",
  values: [
    { title: "Travail écrit", text: "Les décisions se prennent par écrit, avec leurs raisons. On peut les retrouver six mois plus tard." },
    { title: "Peu de réunions", text: "Le temps de concentration est un actif. On le protège." },
    { title: "Livrer souvent", text: "De petites livraisons vérifiées, plutôt que des grands lancements risqués." },
  ],
  process: [
    "Un premier échange d'une trentaine de minutes sur votre parcours et le projet.",
    "Un exercice court et rémunéré, proche de ce que vous feriez au quotidien.",
    "Une restitution avec l'équipe, puis une réponse motivée dans les cinq jours.",
  ],
  benefits: ["Télétravail par défaut, bureaux à disposition", "Matériel de votre choix", "Congés non plafonnés avec minimum obligatoire", "Budget formation annuel"],
};

export const PRESS = {
  eyebrow: "Presse", title: "Ressources presse.",
  lead: "Éléments de marque, description de l'entreprise et contact pour la presse.",
  boilerplate: "Perform est une plateforme française de coaching esport qui propose un accompagnement individuel sur cinq jeux compétitifs. Ouverte en 2026, elle propose des séances à l'unité, sans abonnement, sur les principaux jeux compétitifs.",
  facts: [
    ["Nom", "Perform"],
    ["Activité", "Plateforme de coaching esport"],
    ["Ouverture", "2026"],
    ["Siège", "France"],
    ["Site", "performcustom.com"],
  ],
  assets: [
    { name: "Logotype", text: "Le mot-symbole et sa marque. Ne pas recomposer, ne pas modifier les proportions.", to: "/marque" },
    { name: "Palette", text: "Vert #48705a, encre #292c29, lignes #e9ebe7.", to: "/marque" },
    { name: "Typographie", text: "Manrope pour les titres, DM Sans pour le texte.", to: "/marque" },
  ],
};

export const PARTNERS = {
  eyebrow: "Partenaires", title: "Construire avec nous.",
  lead: "Nous ouvrons le programme partenaire aux structures qui accompagnent des joueurs.",
  kinds: [
    { icon: "Users", title: "Clubs et académies", text: "Faites bénéficier votre roster d'un accompagnement suivi, avec une facturation centralisée." },
    { icon: "Video", title: "Créateurs et streamers", text: "Proposez des séances à votre communauté, avec un lien de parrainage suivi." },
    { icon: "Code2", title: "Partenaires techniques", text: "Intégrez Perform à vos outils via notre API." },
    { icon: "Target", title: "Parrainage", text: "Un lien de parrainage pour vos membres, avec suivi des inscriptions." },
  ],
  notice: "Le programme démarre : les conditions se définissent avec les premiers partenaires. Écrivez-nous, nous répondons à chaque message.",
  cta: { label: "Devenir partenaire", to: "/contact" },
};

export const EXPERTS = {
  eyebrow: "Experts et services", title: "Se faire accompagner.",
  lead: "Pour les structures qui veulent aller plus vite qu'en autonomie.",
  services: [
    { title: "Mise en place", text: "Création des comptes, structuration du roster et des objectifs, prise en main de l'équipe encadrante." },
    { title: "Programme d'entraînement", text: "Construction d'un plan sur une saison, avec des points d'étape réguliers." },
    { title: "Formation de vos encadrants", text: "Outiller vos encadrants : analyse de VOD, conduite de séance, suivi d'objectifs." },
  ],
  notice: "Ces prestations sont assurées directement par le coach, au cas par cas. Il n'existe pas de réseau d'experts : nous ne prétendrons pas le contraire.",
  cta: { label: "Décrire votre besoin", to: "/contact" },
};

export const COMMUNITY = {
  eyebrow: "Communauté", title: "Rejoindre la communauté.",
  lead: "Un endroit pour poser une question, partager une VOD ou trouver des partenaires d'entraînement.",
  channels: [
    { title: "Discord", text: "Le point de rencontre principal : entraide, recherche de partenaires, retours sur le produit.", href: "https://discord.gg/performcustom", external: true, available: false },
    { title: "Communautés dans l'app", text: "Des espaces par jeu, accessibles depuis votre espace.", to: "/communities", available: true },
    { title: "Guides", text: "Les ressources écrites par le coach.", to: "/guides", available: true },
  ],
  notice: "Le serveur Discord ouvrira avec les premiers élèves. En attendant, les espaces communautaires de l'application sont accessibles.",
};

export const ROADMAP = {
  eyebrow: "Feuille de route", title: "Ce sur quoi nous travaillons.",
  lead: "Nous annonçons des intentions et un ordre, pas des dates que nous ne pouvons pas tenir.",
  columns: [
    { key: "now", label: "En cours", items: [
      { title: "Sauvegardes automatiques de la base", text: "Notre principale lacune d'infrastructure. Priorité absolue avant toute nouvelle fonctionnalité." },
      { title: "Envoi d'e-mails en production", text: "Branchement du service d'envoi pour que les liens de connexion partent réellement." },
      { title: "Page du coach et créneaux", text: "Profil public, disponibilités et réservation d'un créneau." },
    ]},
    { key: "next", label: "Ensuite", items: [
      { title: "Réservation et paiement", text: "Réservation d'un créneau, paiement sécurisé, confirmation immédiate du créneau." },
      { title: "Analyse de VOD", text: "Dépôt d'une partie, annotation par le coach, notes consultables après la séance." },
      { title: "Salle de coaching live", text: "Session en direct avec écran partagé et notes partagées." },
    ]},
    { key: "later", label: "Plus tard", items: [
      { title: "Espaces d'équipe", text: "Comptes gérés par une structure, vue d'ensemble du roster, facturation centralisée." },
      { title: "Double authentification et SSO", text: "Pour les structures qui en ont besoin." },
      { title: "Journaux d'audit", text: "Historique d'actions consultable par l'utilisateur." },
    ]},
    { key: "done", label: "Livré", items: [
      { title: "Connexion sans mot de passe", text: "Lien à usage unique valable 15 minutes." },
      { title: "Onboarding en trois étapes", text: "Profil, jeu et objectif, puis liste de prise en main." },
      { title: "Trust Center et documentation", text: "Posture de sécurité détaillée, documentation d'API et documents juridiques." },
    ]},
  ],
  vote: "Une fonctionnalité vous manque ? Écrivez-nous : nous n'avons pas encore de système de vote, mais chaque message est lu et compte.",
};

export const INTEGRATIONS = {
  eyebrow: "Intégrations", title: "Connecter Perform à vos outils.",
  lead: "Ce qui est disponible aujourd'hui, et ce qui est prévu.",
  notice: "Aucune intégration n'est encore disponible. L'API publique permet dès maintenant de construire la vôtre.",
  categories: ["Communication", "Streaming", "Productivité", "Développeur", "Paiement"],
  items: [
    { name: "API HTTP", category: "Développeur", text: "Authentification par session et accès aux données de votre compte.", to: "/developpeurs", available: true },
    { name: "Discord", category: "Communication", text: "Notifications de séance et rôles selon le palier.", available: false },
    { name: "Twitch", category: "Streaming", text: "Lier sa chaîne à son profil de coach.", available: false },
    { name: "OBS", category: "Streaming", text: "Panneau de session pendant un direct.", available: false },
    { name: "Google Agenda", category: "Productivité", text: "Synchronisation des créneaux et des séances.", available: false },
    { name: "Stripe", category: "Paiement", text: "Paiement des séances et versement aux coachs.", available: false },
    { name: "Webhooks", category: "Développeur", text: "Recevoir un appel HTTP à chaque événement.", available: false },
  ],
};

export const BRAND = {
  eyebrow: "Marque", title: "Utiliser la marque Perform.",
  lead: "Quelques règles simples pour que le logo reste reconnaissable.",
  rules: {
    do: ["Utiliser le logotype fourni, sans le recomposer", "Conserver une marge libre égale à la hauteur du symbole", "Utiliser le vert #48705a ou le noir d'encre #292c29 sur fond clair"],
    dont: ["Modifier les proportions, la couleur ou la graisse", "Ajouter un contour, une ombre ou un dégradé", "Placer le logo sur un fond qui nuit à sa lisibilité", "Laisser entendre un partenariat qui n'existe pas"],
  },
  palette: [
    { name: "Vert Perform", hex: "#48705a", use: "Accent, états actifs" },
    { name: "Encre", hex: "#292c29", use: "Texte principal, boutons" },
    { name: "Ligne", hex: "#e9ebe7", use: "Séparateurs, bordures" },
    { name: "Fond doux", hex: "#f7f8f6", use: "Sections secondaires" },
  ],
  type: [
    { name: "Manrope", use: "Titres et chiffres", weights: "600, 700, 800" },
    { name: "DM Sans", use: "Texte courant et interface", weights: "400, 500, 550" },
  ],
};


export const CONTACTS = [
  { key: "support", icon: "LifeBuoy", title: "Support", text: "Un problème sur votre compte, une séance ou l'application.", email: "support@performcustom.com", note: "Réponse en heures ouvrées." },
  { key: "sales", icon: "Users", title: "Clubs et structures", text: "Un accompagnement pour votre équipe, votre académie ou votre école.", email: "bonjour@performcustom.com" },
  { key: "security", icon: "ShieldCheck", title: "Sécurité", text: "Signaler une vulnérabilité ou un comportement suspect.", email: "securite@performcustom.com", note: "Accusé de réception sous 72 h.", to: "/securite/divulgation" },
  { key: "privacy", icon: "BookOpen", title: "Données personnelles", text: "Exercer vos droits d'accès, de rectification ou d'effacement.", email: "confidentialite@performcustom.com", note: "Réponse sous un mois." },
  { key: "press", icon: "GitCommitHorizontal", title: "Presse", text: "Demande d'information ou d'interview.", email: "presse@performcustom.com", to: "/presse" },
  { key: "partners", icon: "Target", title: "Partenariats", text: "Programme partenaire, parrainage, intégrations.", email: "partenaires@performcustom.com", to: "/partenaires" },
];

export const SUPPORT_TIERS = [
  { name: "Tout le monde", items: ["Centre d'aide", "Documentation", "Espaces communautaires"], available: true },
  { name: "Comptes actifs", items: ["Support par e-mail en heures ouvrées"], available: true },
  { name: "Clubs et structures", items: ["Interlocuteur identifié", "Accord de traitement des données"], available: true,
    note: "Nous n'affichons pas d'engagement de délai contractuel tant que nous ne pouvons pas le tenir : il n'y a pas d'astreinte 24/7 aujourd'hui." },
];

// Pages de détail des fonctionnalités, ciblées par le méga-menu.
export const FEATURE_DETAILS = {
  "analyse-video": {
    eyebrow: "Analyse de VOD", title: "Vos parties, décortiquées.", status: "building",
    lead: "Déposez une partie, le coach l'annote moment par moment et vous laisse des notes qui restent accessibles après la séance.",
    how: [
      { title: "Vous déposez", text: "Un lien ou un fichier. Le coach le reçoit avant la séance et peut le préparer." },
      { title: "Le coach annote", text: "Des marqueurs sur la frise, une remarque par moment clé. Trois erreurs bien expliquées valent mieux que trente." },
      { title: "Vous relisez", text: "Les notes restent dans votre espace. Vous y revenez entre deux séances, quand la situation se représente." },
    ],
    why: "Regarder sa propre partie sans méthode ne sert presque à rien : on revoit ce qu'on croyait déjà savoir. Un œil extérieur voit les schémas qui se répètent.",
  },
  "coaching-live": {
    eyebrow: "Coaching live", title: "Une séance, en direct.", status: "building",
    lead: "Salle de session avec écran partagé et prise de notes partagée. Ni Discord à configurer, ni lien à retrouver.",
    how: [
      { title: "Un lien, une salle", text: "La salle s'ouvre à l'heure du créneau. Pas de logiciel à installer." },
      { title: "Écran partagé", text: "Vous jouez, le coach commente. Ou l'inverse : il montre, vous reproduisez." },
      { title: "Notes partagées", text: "Ce qui est écrit pendant la séance reste dans votre espace après." },
    ],
    why: "Le direct permet de corriger au moment où l'erreur se produit, pas trois jours plus tard sur un enregistrement.",
  },
  "smart-match": {
    eyebrow: "Smart Match", title: "Le bon coach, en trois questions.", status: "building",
    lead: "Votre jeu, votre palier, votre objectif. Nous adaptons le module et le format à ce que vous venez chercher, plutôt qu'une séance générique.",
    how: [
      { title: "Trois questions", text: "Le jeu, le niveau actuel, ce que vous voulez travailler. Une minute, pas plus." },
      { title: "Une sélection courte", text: "Trois à cinq profils pertinents plutôt qu'une liste interminable." },
      { title: "Vous gardez la main", text: "La recommandation est un point de départ. Tous les filtres restent accessibles." },
    ],
    why: "Le choix excessif paralyse. Face à deux cents profils, la plupart des joueurs ne réservent rien.",
  },
  "perform-ai": {
    eyebrow: "Perform AI", title: "Un analyste entre deux séances.", status: "building",
    lead: "Des repères sur votre progression et vos points faibles récurrents, entre deux rendez-vous avec votre coach.",
    how: [
      { title: "À partir de vos séances", text: "Les notes de vos coachs et vos objectifs, pas vos données de jeu brutes." },
      { title: "Des rappels utiles", text: "Ce que vous deviez travailler, rappelé au bon moment." },
      { title: "Jamais à la place du coach", text: "Un outil de rappel et de synthèse, pas un remplacement." },
    ],
    why: "Entre deux séances, on oublie. Un rappel au bon moment vaut mieux qu'une analyse spectaculaire.",
    notice: "Aucune donnée n'est aujourd'hui envoyée à un fournisseur de modèle. Les règles sont posées à l'avance sur la page Transparence IA.",
  },
};
